module.exports = __webpack_public_path__ + "static/media/ready_to_take_survey_bear.8ba7138c.png";